import React, { useCallback } from 'react';
import { bool, func, number, oneOf, oneOfType, shape } from 'prop-types';
import { Button } from 'react-bootstrap';

const PageNavButton = ({ page, disabled, paginateUser }) => {
    const handleNavigation = useCallback(() => {
        if (page?.page !== null) {
            paginateUser(page.page);
        }
    }, [page, paginateUser]);

    return <Button
        aria-label={'Go to page ' + page.displayPage}
        key={'page-' + page.page}
        onClick={handleNavigation}
        className={'page--list-btn-number'}
        disabled={disabled}>
        {page.displayPage}
    </Button>;
};

const PageNavButtonProps = {
    page: shape({
        page: oneOfType([number, oneOf([null])]),
        displayPage: oneOfType([number, oneOf(['...'])]),
    }),
    disabled: bool,
    paginateUser: func,
};
PageNavButton.propTypes = PageNavButtonProps;
export default PageNavButton;